import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { UiIcon, UiNavLink } from 'shared/uikit-new';
import { ROUTES } from 'shared/constants';
import { getAdminPanelLink } from 'shared/utilities';
import { ApplicationModule } from 'shared/modules';
import { PermissionEnum } from 'shared/enums';
import { useObservable } from 'shared/hooks';

import './styles.scss';

const logo = require('./assets/logo.svg').default;
const icon = require('./assets/icon.svg').default;

export const LayoutMenu = observer(() => {
    const store = useObservable({
        isOpened: false,
        currentYear: new Date().getFullYear()
    });

    const className = classnames('layout-menu', {
        'layout-menu--opened': store.isOpened,
    });

    const groups = [[{
        isVisible: ApplicationModule.user.isAvailableDashboard,
        isExternal: false,
        name: 'Дашборд',
        route: ROUTES.PROFILE_DASHBOARD(),
        icon: UiIcon.ChartNoAxesCombined,
    }, {
        isVisible: true,
        isExternal: false,
        name: 'Задачи',
        route: ROUTES.TASK_TRACKER('personal'),
        icon: UiIcon.ListTodo,
    }, {
        isVisible: ApplicationModule.user.can(PermissionEnum.WebCalendarAndReservation),
        isExternal: false,
        name: 'Календарь',
        route: ROUTES.CALENDAR(),
        icon: UiIcon.CalendarDays,
    }, {
        isVisible: ApplicationModule.user.can(PermissionEnum.WebCalendarAndReservation),
        isExternal: false,
        name: 'Переговорная',
        route: ROUTES.RESERVATIONS(),
        icon: UiIcon.MessagesSquare,
    }], [{
        isVisible: true,
        isExternal: false,
        name: 'Пропуска',
        route: ROUTES.ENTRY_PASSES(),
        icon: UiIcon.IdCard,
    },{
        isVisible: true,
        isExternal: false,
        name: 'Заявки',
        route: ROUTES.REQUESTS(),
        icon: UiIcon.NotebookPen,
    }, {
        isVisible: true,
        isExternal: false,
        name: 'Документы',
        route: ROUTES.DOCUMENTS(),
        icon: UiIcon.FileSearch,
    },], [{
        isVisible: true,
        isExternal: false,
        name: 'Компания',
        route: ROUTES.COMPANY(),
        icon: UiIcon.Network,
    }, {
        isVisible: true,
        isExternal: false,
        name: 'Сотрудники',
        route: ROUTES.COMPANY_STRUCTURE(),
        icon: UiIcon.Users,
    },], [{
        isVisible: ApplicationModule.user.can(PermissionEnum.WebCafe),
        isExternal: false,
        name: 'Столовая',
        route: ROUTES.CAFE(),
        icon: UiIcon.Soup,
    }, {
        isVisible: true,
        isExternal: false,
        name: 'База знаний',
        route: ROUTES.LIBRARY(),
        icon: UiIcon.BookMarked,
    }, {
        isVisible: true,
        isExternal: false,
        name: 'Обучение и адаптация',
        route: ROUTES.EDUCATION(),
        icon: UiIcon.Blocks,
    }, {
        isVisible: true,
        isExternal: false,
        name: 'Опросы',
        route: ROUTES.SURVEYS(),
        icon: UiIcon.MessageCircleHeart,
    }, {
        isVisible: true,
        isExternal: false,
        name: 'Вакансии',
        route: ROUTES.VACANCIES(),
        icon: UiIcon.ScanSearch,
    }, {
        isVisible: true,
        isExternal: false,
        name: 'Togas Life',
        route: ROUTES.LIFE(),
        icon: UiIcon.Radio,
    },], [{
        isVisible: ApplicationModule.user.can(PermissionEnum.AdminPanel),
        isExternal: true,
        name: 'Админ панель',
        route: getAdminPanelLink(),
        icon: UiIcon.ShieldCheck,
    },],];

    return (
        <div className={className}>
            <div className='layout-menu__inner'>
                <div className='layout-menu-header'>
                    <UiNavLink to={ROUTES.HOME()} className={'layout-menu-header__logo'} style={{ backgroundImage: `url(${logo})` }} />
                    <UiNavLink to={ROUTES.HOME()} className={'layout-menu-header__icon'} style={{ backgroundImage: `url(${icon})` }} />
                    <div className='layout-menu-header__pin' onClick={() => store.set('isOpened', !store.isOpened)}>
                        <UiIcon.Pin size={20} />
                    </div>
                    <div className='layout-menu-header__close' onClick={() => store.set('isOpened', !store.isOpened)}>
                        <UiIcon.ChevronLeft size={20} />
                    </div>
                </div>
                <div className='layout-menu-items'>
                    <div className='layout-menu-items__inner'>
                        {groups.map((items, index) => {
                            if (items.every(item => !item.isVisible)) {
                                return null;
                            }
                            return (
                                <div key={index} className={'layout-menu-items__group'}>
                                    {items.map((item, index) => {
                                        const { icon: Icon } = item;
                                        if (!item.isVisible) {
                                            return null;
                                        }
                                        if (item.isExternal) {
                                            return (
                                                <a key={item.route} className='layout-menu-item' href={item.route} target='_blank' rel='noreferrer'>
                                                    <Icon size={24} />
                                                    <span>{item.name}</span>
                                                </a>
                                            );
                                        }
                                        return (
                                            <UiNavLink
                                                key={item.route}
                                                to={item.route}
                                                className={'layout-menu-item'}
                                            >
                                                <Icon className={'layout-menu-item__icon'} size={24} />
                                                <span>{item.name}</span>
                                            </UiNavLink>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className='layout-menu-footer'>
                    © { store.currentYear } <span>Togas House of Textiles.</span>
                </div>
            </div>
        </div>
    );
});
